<script setup lang="ts">
    import {computed} from 'vue';
    import ChatCheckmarkIcon from '../ui/ChatCheckmarkIcon.vue';
    import {vehicleSpecs, vehicleTitle} from './vehicleFormat';

    const props = defineProps<{vehicle: Record<string, any>}>();

    const title = computed(() => vehicleTitle(props.vehicle, 'Voertuig gevonden'));
    const specs = computed(() => vehicleSpecs(props.vehicle));
</script>

<template>
    <div class="vehicle-card">
        <div class="vehicle-card__found">
            <ChatCheckmarkIcon :size="18" />
            <span>Auto gevonden</span>
        </div>

        <div class="vehicle-card__title">{{ title }}</div>
        <div
            v-if="specs"
            class="vehicle-card__specs">
            {{ specs }}
        </div>

        <!--
            The design confirms the car here with "Ja, dit is mijn auto" / "Dit is niet mijn auto".
            Left out: the search resolver writes a resolved plate's car straight onto the turn state
            and the same turn already searches with it, so there is no pending-confirmation step for those
            buttons to answer. Wiring it up needs a confirm/reject signal on the turn (and a way to
            drop the resolved car again) before the UI can offer it.

            vehicle.image (the brand logo, the only image the car API returns) is available here too
            if this card should carry it.
        -->
    </div>
</template>

<style scoped lang="scss">
    @import '../../../sass/globals';

    .vehicle-card {
        padding: 14px 16px;
        border: 1px solid #788a6d;
        border-radius: 4px;
        background: $ultra-light-green;
    }

    .vehicle-card__found {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 700;
        color: $green;
        letter-spacing: 0.02em;
    }

    .vehicle-card__found svg {
        flex-shrink: 0;
    }

    .vehicle-card__title {
        margin-top: 9px;
        font-size: 20px;
        font-weight: 900;
        line-height: 1.2;
        color: $black;
    }

    .vehicle-card__specs {
        margin-top: 3px;
        font-size: 14px;
        line-height: 1.5;
        color: #5e7052;
    }
</style>
